/* istanbul ignore file */
import React from 'react';
import { useAssetUrl } from 'domain/finance/assets/shared/useAssetRouting';
import { LinkButton } from 'framework/ui/ui-builder';

const ViewAssetButton = (props: any) => {
  const { getSingleEntityUrl } = useAssetUrl();

  return (
    <LinkButton url={getSingleEntityUrl} key="view-asset" outline {...props}>
      View
    </LinkButton>
  );
};

export default ViewAssetButton;
